import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import packageJson from '../package.json';
import { ENVIRONMENTS } from './consts/env';
import { Environment } from './types/env';
import { getEnv } from './utils/env';

const environmentsWithoutVersion: Environment[] = [
  ENVIRONMENTS.STAGING,
  ENVIRONMENTS.STAGING_NEW,
  ENVIRONMENTS.DEVELOPMENT,
];

const getVersion = () => {
  if (environmentsWithoutVersion.includes(getEnv())) {
    return Date.now().toString();
  }

  // @ts-ignore
  return packageJson.version || Date.now().toString();
};

export const i18nInitPromise = i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: getVersion() },
    },
  });

export default i18nInitPromise;
